import { DOMJSON } from '../pendoAnnouncments.types';

interface GroupedByType {
  [key: string]: DOMJSON[];
}

/**
 *
 * Group the nodes by their element type
 *
 */
function groupByType(node: DOMJSON, grouped: GroupedByType): void {
  if (!node) return;
  if (!node.type) return;
  if (!grouped[node.type]) {
    grouped[node.type] = [];
  }
  grouped[node.type].push(node);

  if (node.children) {
    for (const child of node.children) {
      groupByType(child, grouped);
    }
  }
}

/**
 *
 * Traverse the DOM JSON array and group the nodes by their element type
 *
 */
function traverseAndGroupByType(domJSONArray: DOMJSON[]): GroupedByType | null {
  if (!domJSONArray.length) return null;
  const grouped: GroupedByType = {};

  for (const node of domJSONArray) {
    groupByType(node, grouped);
  }
  return grouped;
}

export { traverseAndGroupByType };
export type { GroupedByType };
